import { useRouter } from "next/router";
import { useEffect } from "react";

export default function ErrorPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/home");
  }, []);

  return <></>;
  // return <CustomErrorComponent statusCode={404} />;
}
